import './optional/swiper.js';
import './components/flexible_content.js';
import './components/submenu.js';
import './components/fancybox.js';
import './components/woocommerce.js';
import './components/smoothscroll.js';
import './components/faq.js';
import './components/page-banner.js';

// Vue
import './components/dealers.js';
import './components/posts.js';
import './components/products.js';

/*
    Remove top header when scrolled past 5 px
 */
var header = document.querySelector('.header');
$(window).scroll(function() {
    if ( $(window).scrollTop() >  24 ) {
        header.classList.add('header--scroll');
    } else {
        header.classList.remove('header--scroll');
    }
});